import React from "react";
import "./BrandLogo.css";

/**
 * AutoTrade Port — typographic wordmark (no clip-art icon).
 * variant: "dark" | "light"
 * compact: single-line lockup for header
 */
function BrandLogo({ variant = "dark", compact = false, onClick, className = "" }) {
  return (
    <button
      type="button"
      className={`brand-logo brand-logo--${variant} ${compact ? "brand-logo--compact" : ""} ${className}`}
      onClick={onClick}
      aria-label="AutoTrade Port home"
    >
      <span className="brand-logo__accent" aria-hidden />
      <span className="brand-logo__text">
        <span className="brand-logo__name">
          <span className="brand-logo__line">
            <span className="brand-logo__auto">Auto</span>
            <span className="brand-logo__trade">Trade</span>
          </span>
          <span className="brand-logo__port">Port</span>
        </span>
        {!compact ? (
          <span className="brand-logo__tagline">Buy &amp; sell vehicles worldwide</span>
        ) : null}
      </span>
    </button>
  );
}

export default BrandLogo;
